module.exports = __webpack_public_path__ + "files/4df097cf2a199e41efdd789bce9a87dc.svg";